import { useState, useEffect } from "react";

/**
 * Debounces a value: the returned value only updates after `delay` ms
 * of inactivity. Ideal for search inputs — the query fires only when
 * the user stops typing, not on every keystroke.
 */
export function useDebounce<T>(value: T, delay: number = 350): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
